import React from "react";
import { TitleText } from "./TitleElements";

const Title = () => {
  return <TitleText>Covid-19 Data</TitleText>;
};

export default Title;
